import { IQuiz } from '../IQuiz'

export const ocpPatterns7: IQuiz = {
  name: 'ocp-patterns-7',
  question: 'Чем полезен механизм подписки шаблона «Наблюдатель»?',
  variants: [
    {
      text:
        'Позволяет создать объект, который уведомляет другие объекты о неком событии без необходимости связывать их напрямую'
    },
    {
      text:
        'Позволяет создавать объекты, которые могут реагировать на события в наблюдаемом объекте без необходимости менять код наблюдаемого объекта'
    },
    {
      text: 'Позволяет динамически подписывать наблюдателей на события и отписывать их от событий'
    }
  ],
  meta: {
    correctAnswers: [0, 1, 2]
  }
}
